module.exports = __webpack_public_path__ + "static/media/banner.b2abb67a.png";